import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Active, ActiveButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_ACTIVE_BUTTONS, RAISED_ACTIVE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedActiveButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={ActiveButton} span={RAISED_ACTIVE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn active color="primary" className="btn-pill btn-air-primary" id="Tooltip-29">{Active}</Btn>
        <ToolTip target="Tooltip-29" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-air-primary active</ToolTip>
        {RAISED_ACTIVE_BUTTONS_LIST.map((data, index) => (
          <CommonRaisedButton key={index} item={data} />
        ))}
      </CardBody>
    </Card>
  );
};

export default RaisedActiveButtons;
